import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, SubmissionError } from "redux-form";
import { compose, withHandlers } from "recompose";
import FontIcon from "react-md/lib/FontIcons";
import Button from "react-md/lib/Buttons/Button";

import TextField from "../../form/TextField";

import { setActiveForm } from "../../../actions/appActions";
import { updateUser, getUser } from "../../../actions/userActions";
import {DebugElement} from "../../../Atollon/debug";

const Info = ({ handleSubmit, activeForm, setActiveForm, initialValues }) => (
  <div className="flex-col">
      <DebugElement text={"src/components/settings/profile/Info.js"}/>
    {initialValues && (
      <div className="flex-row">
        <p className="profile-label">E-mail:</p>
        <p>{initialValues.identifier}</p>
      </div>
    )}

    {activeForm === "profileInfo" ? (
      <form className="profile-form" onSubmit={handleSubmit}>
          <div className="touchButtons-spaceAbove" />

          <Field component={TextField} label="Jméno" name="firstName" />
          <Field component={TextField} label="Příjmení" name="name" />

          <div className="touchButtons-spaceAbove" />

          <div className="flex-row">
              <Button
                raised
                className="btn touchButton-5"
                label="Zrušit"
                onClick={() => setActiveForm(null)}
              />
              <div className="touchButtons-spaceBetween" />

              <Button
                raised
                className="btn btn-primary touchButton-6"
                label="Uložit"
                type="submit"
              />
          </div>
      </form>
    ) : (
      <div
        className="flex-row profile-editable"
        onClick={() => setActiveForm("profileInfo")}
      >
        <p className="profile-label">Jméno:</p>
        <p>
          {initialValues.firstName} {initialValues.name}
        </p>
        <FontIcon className="edit">edit</FontIcon>
      </div>
    )}
  </div>
);

export default compose(
  connect(({ app: { form: { activeForm } } }) => ({ activeForm }), {
    setActiveForm,
    updateUser,
    getUser
  }),
  withHandlers({
    onSubmit: () => async (formData, dispatch, props) => {
      const { user, updateUser, setActiveForm, getUser } = props;
      const { name, firstName } = formData;
      if (
        await updateUser({
          ...user,
          contact: { name, firstName, middleName: "" }
        })
      ) {
        getUser();
        setActiveForm(null);
      } else {
        throw new SubmissionError({
          name: "Update se nezdařil."
        });
      }
    }
  }),
  reduxForm({ form: "profileInfo", enableReinitialize: true })
)(Info);



// WEBPACK FOOTER //
// ./src/components/settings/profile/Info.js